// extracted by mini-css-extract-plugin
module.exports = {"CourseIdea":"CourseIdea_CourseIdea__c097t"};